import type { ReactNode } from 'react';
import { Link } from '../lib/router.tsx';
import { useI18n } from '../lib/i18n.tsx';
import { Icon } from './Icon.tsx';

export function PageHead({ title, sub, crumbs = [], actions }: { title: ReactNode; sub?: ReactNode; crumbs?: Array<{ label: string; to?: string }>; actions?: ReactNode }) {
  const { t } = useI18n();
  return (
    <div className="page-head">
      <div style={{ minWidth: 0 }}>
        <div className="crumbs"><Link to="/">{t('nav.home', {})}</Link>{crumbs.map((c, i) => <span key={i} className="row" style={{ gap: 6 }}><Icon name="ChevronRight" size={12} className="rtl-flip" />{c.to ? <Link to={c.to}>{c.label}</Link> : <span>{c.label}</span>}</span>)}</div>
        <h1>{title}</h1>
        {sub && <div className="sub">{sub}</div>}
      </div>
      {actions && <div className="actions">{actions}</div>}
    </div>
  );
}
